// src/api/blogApi.js
import axios from 'axios';
import { attachAuthInterceptors } from './attachInterceptors';
import { createApi } from './createApi';
export const initBlogApi = (logout) => createApi(process.env.REACT_APP_API_BLOG, logout);

const blogApi = axios.create({
  baseURL: process.env.REACT_APP_API_BLOG,
  headers: { 'Content-Type': 'application/json' }
});

attachAuthInterceptors(blogApi);

export default blogApi;
